import { Drawer } from '@mui/material';
import { BulkShiftCreationForm } from './bulk-shift-creation-form/bulk-shift-creation-form';

type Props = {
  isOpen: boolean;
  setIsBarSideBarOpen: (isOpen: boolean) => void;
};

export const BulkShiftCreationSidebar = ({ isOpen, setIsBarSideBarOpen }: Props) => {
  const handleClose = () => {
    setIsBarSideBarOpen(false);
  };

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={handleClose}
      PaperProps={{ style: { width: 600 } }}
    >
      <BulkShiftCreationForm onClose={handleClose} />
    </Drawer>
  );
};
